import { DarkTheme, LightTheme } from "styled-components";
import { backgroundsDark, backgroundsLight, textDark, textLight } from "../Configs/Config";
import {  defaultGradient, defaultGradientEnd, defaultGradientStart, defaultGradientVerticle, goldAccent, navBarDarkTheme, navBarLightTheme, purpleGreenGradient, secondaryGradient } from "./ColorPallette";


const lightTheme : LightTheme = {
    colors : {
        text:textLight,
        background:backgroundsLight,
        backgroundOpposite: backgroundsDark,
        textOpposite:textDark,
        accentMain:goldAccent,
        accentOne:defaultGradientStart,
        accentTwo:defaultGradientEnd,
        navBackground:navBarLightTheme,
        navBackgroundOpposite:navBarDarkTheme
    },
    gradient : {
        default:defaultGradient,
        secondary:secondaryGradient,
        purpleGreen:purpleGreenGradient,
        gradientStart: defaultGradientStart,
        gradientEnd: defaultGradientEnd,
        defaultVerticle: defaultGradientVerticle
    },
    animationTime : {
        short: 0.5,
        medium: 2,
        long: 3,
    },
    breakpoint : 900,
    particlesBackground : {
        color: '#fff',
        image: "",
        position: "50% 50%",
        repeat: "no-repeat",
        size: "cover",
    },
}

const darkTheme : DarkTheme = {
    colors : {
        text : textDark,
        background: backgroundsDark,
        backgroundOpposite: backgroundsLight,
        textOpposite:textLight,
        accentMain:goldAccent,
        accentOne:defaultGradientStart,
        accentTwo:defaultGradientEnd,
        navBackground:navBarDarkTheme,
        navBackgroundOpposite: navBarLightTheme
    },
    gradient : {
        default:defaultGradient,
        secondary:secondaryGradient,
        purpleGreen:purpleGreenGradient,
        gradientStart: defaultGradientStart,
        gradientEnd: defaultGradientEnd,
        defaultVerticle: defaultGradientVerticle
    },
    animationTime : {
        short: 0.5,
        medium: 2,
        long: 3,
    },
    breakpoint: 900,
    particlesBackground : {
        color: '#000',
        image: "",
        position: "50% 50%",
        repeat: "no-repeat",
        size: "cover",
    },
}


export {lightTheme,darkTheme};